var map = {
	"./01_table_ukraine": [
		186,
		1,
		0,
		2
	],
	"./01_table_ukraine.js": [
		186,
		1,
		0,
		2
	],
	"./02_table_administration": [
		187,
		1,
		0,
		3
	],
	"./02_table_administration.js": [
		187,
		1,
		0,
		3
	],
	"./03_table_climate": [
		188,
		1,
		0,
		4
	],
	"./03_table_climate.js": [
		188,
		1,
		0,
		4
	],
	"./04_table_migration": [
		189,
		1,
		0,
		5
	],
	"./04_table_migration.js": [
		189,
		1,
		0,
		5
	],
	"./05_table_foreign_policy": [
		190,
		1,
		0,
		6
	],
	"./05_table_foreign_policy.js": [
		190,
		1,
		0,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 428;
module.exports = webpackAsyncContext;